import { render, staticRenderFns } from "./ImportLogTable.vue?vue&type=template&id=1c82e85c&scoped=true&"
import script from "./ImportLogTable.vue?vue&type=script&lang=js&"
export * from "./ImportLogTable.vue?vue&type=script&lang=js&"
import style0 from "./ImportLogTable.vue?vue&type=style&index=0&id=1c82e85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82e85c",
  null
  
)

export default component.exports